export default "__VITE_ASSET__5a22cc0b__"